module.exports = __webpack_public_path__ + "static/img/parts-logo-wide.6897263.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parts-logo-wide.png
// module id = EFHW
// module chunks = 1